export const LIVE_MAP_TRANSLATIONS = {
  "live_map.nav": "Carte vivante",
  "live_map.title": "Carte vivante Eternua",
  "live_map.hero": "Découvrez ce qui vit autour de vous, sans révéler votre adresse.",
  "live_map.approximate": "Position et distance approximatives",
  "live_map.list": "Liste",
  "live_map.map": "Carte",
  "live_map.use_position": "Utiliser ma position une fois",
  "live_map.position_help": "Votre position est arrondie immédiatement, utilisée pour cette recherche puis oubliée.",
  "live_map.manual_label": "Ville ou code postal",
  "live_map.manual_placeholder": "Ex. Lyon ou 69001",
  "live_map.search": "Rechercher",
  "live_map.search_area": "Rechercher dans cette zone",
  "live_map.filters": "Filtres",
  "live_map.clear_filters": "Effacer les filtres",
  "live_map.categories": "Catégories",
  "live_map.radius": "Rayon",
  "live_map.free": "Gratuit uniquement",
  "live_map.results": "résultats",
  "live_map.no_results": "Aucun résultat avec les filtres actuels.",
  "live_map.initial": "Choisissez une ville, un code postal ou utilisez ponctuellement votre position.",
  "live_map.loading": "Recherche autour de cette zone…",
  "live_map.error": "La recherche n’a pas pu aboutir. Réessayez.",
  "live_map.offline": "Vous êtes hors ligne. La dernière liste affichée reste disponible.",
  "live_map.provider_missing": "Carte vivante bientôt disponible",
  "live_map.list_still_works": "La recherche par ville et la vue liste restent entièrement utilisables.",
  "live_map.privacy_title": "Votre vie privée reste au centre",
  "live_map.privacy_text": "Aucune adresse exacte, position en direct, direction vers une habitation ou heure de présence n’est affichée.",
  "live_map.detail": "Fiche compacte",
  "live_map.hide": "Masquer ce contenu",
  "live_map.block": "Bloquer ce membre",
  "live_map.report": "Signaler un problème de localisation",
  "live_map.close": "Fermer",
  "live_map.publish_title": "Mes publications sur la Carte vivante",
  "live_map.publish_text": "Chaque contenu nécessite un consentement indépendant. La visibilité est désactivée par défaut.",
  "live_map.visible": "Visible sur la Carte vivante",
  "live_map.hidden": "Non visible",
  "live_map.zone": "Zone publique affichée",
  "live_map.precision": "Niveau d’approximation",
  "live_map.standard": "Zone standard",
  "live_map.wide": "Zone élargie",
  "live_map.consent": "Je confirme vouloir rendre ce contenu visible dans cette zone approximative.",
  "live_map.activate": "Activer la visibilité",
  "live_map.deactivate": "Désactiver immédiatement",
  "live_map.photo_warning": "Vérifiez que votre description et vos photos ne révèlent pas involontairement une adresse ou un lieu privé.",
  "live_map.activity_title": "Je recherche une activité",
  "live_map.activity_text": "Publication volontaire, temporaire et réservée aux membres majeurs vérifiés.",
  "live_map.activities": "Activités recherchées",
  "live_map.availability": "Disponibilité générale",
  "live_map.duration": "Durée",
  "live_map.publish_activity": "Publier ma recherche",
  "live_map.revoke_activity": "Retirer ma recherche",
  "live_map.location_denied": "Localisation refusée. Utilisez la recherche par ville ou code postal.",
  "live_map.location_unavailable": "Localisation indisponible. La vue liste reste accessible.",
};
